<section class="testimonials-section position-relative py-5">
    <!-- Dark overlay for readability -->
    <div class="testimonials-overlay"></div>

    <div class="container-fluid px-lg-5 position-relative z-3 py-4">
        <!-- Section Header -->
        <div class="text-center mb-5 animate-on-scroll fade-up">
            <h2 class="section-title text-white">Students Testimonials</h2>
            <div class="title-underline">
                <span class="line-segment"></span>
                <span class="line-segment accent"></span>
            </div>
        </div>

        <!-- Slider Container -->
        <div class="testimonials-slider-wrap position-relative mt-5 animate-on-scroll zoom-in stagger-1">
            <!-- Left Arrow -->
            <button class="nav-arrow prev-arrow" (click)="prev()" aria-label="Previous Testimonial">
                <i class="fas fa-chevron-left"></i>
            </button>

            <!-- Testimonials Grid (Desktop: 2 Cards, Mobile: 1 Card via CSS) -->
            <div class="testimonials-grid">
                <!-- Card 1 -->
                <div class="testimonial-card animate-card">
                    <div class="card-inner">
                        <div class="student-img-wrap">
                            <img [src]="testimonials[activeStartIndex].image" [alt]="testimonials[activeStartIndex].name"
                                 onerror="this.src='https://placehold.co/150x150/cccccc/333333?text='+testimonials[activeStartIndex].name" />
                        </div>
                        <div class="student-content">
                            <p class="testimonial-quote">{{ testimonials[activeStartIndex].text }}</p>
                            <h4 class="student-name">{{ testimonials[activeStartIndex].name }}</h4>
                            <span class="student-role">{{ testimonials[activeStartIndex].role }}</span>
                        </div>
                    </div>
                </div>

                <!-- Card 2 -->
                <div class="testimonial-card animate-card second-card">
                    <div class="card-inner">
                        <div class="student-img-wrap">
                            <img [src]="testimonials[(activeStartIndex + 1) % testimonials.length].image" [alt]="testimonials[(activeStartIndex + 1) % testimonials.length].name"
                                 onerror="this.src='https://placehold.co/150x150/cccccc/333333?text='+testimonials[(activeStartIndex + 1) % testimonials.length].name" />
                        </div>
                        <div class="student-content">
                            <p class="testimonial-quote">{{ testimonials[(activeStartIndex + 1) % testimonials.length].text }}</p>
                            <h4 class="student-name">{{ testimonials[(activeStartIndex + 1) % testimonials.length].name }}</h4>
                            <span class="student-role">{{ testimonials[(activeStartIndex + 1) % testimonials.length].role }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right Arrow -->
            <button class="nav-arrow next-arrow" (click)="next()" aria-label="Next Testimonial">
                <i class="fas fa-chevron-right"></i>
            </button>
        </div>
    </div>
</section>
